<template>
  <v-container>
    <!-- Componen mensajes de informacion -->
    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>

    <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
    <v-snackbar :color="colorsnackbarAlert" v-model="snackbarAlert" :timeout="timeout" top>
      <v-icon>mdi-message</v-icon>
      {{ SnackbarTextAlert }}

      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbarAlert = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <v-row>
      <v-col cols="12">
        <v-sheet color="transparent" class="" v-if="readyload">
          <v-skeleton-loader class="mx-auto" type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
        </v-sheet>
        <ComundataTablecomp v-else :headers="headersUnidad" whitSearch :search="search" :items="progAlumno"
          noResultsText="No hay datos disponibles, seleccionar Área y Curso" group-by="nombre_tema">
          <!-- sort-by="nombre_tema"  CONFIGURAR EL COMPONENTE GLOBAL  -->
          <template v-slot>
            <v-row class="d-flex justify-end">
              <v-col cols="12" md="5">
                <AutocompleteComp textLabel="Seleccionar área" v-model="filtroProgAlum.id_area" :items="areaAlumno"
                  item-value="id_area_mant" item-text="desc_area" @change="selectArea" />
              </v-col>
              <v-col cols="12" md="5">
                <AutocompleteComp textLabel="Seleccionar curso" v-model="filtroProgAlum.id_curso" :items="cursoAlumFilter"
                  :isDisable="inhabilitarCursoAlum" item-value="id_curso" item-text="desc_curso" @change="selectCurso" />
              </v-col>

            </v-row>
          </template>
          <template v-slot:accion_preguntar="{ item }">
            <ButtonComp :loading="loadingPregunta.includes(item.id_clase)"
              :disabled="loadingPregunta.includes(item.id_clase)" classColor="green"
              :class-button="classAnimate + ' ma-2 white--text'"
              @click="simularExamen(item.tipo_contenido, item.id_clase)" textButton="Crear simulación"
              iconBut="mdi mdi-comment-question-outline" />
          </template>
          <template v-slot:accion_ver="{ item }">
            <ButtonComp :loading="loadingBanco[item.id_clase]" disabled verButton tooltipText="Ver banco de preguntas"
              @click="verBancoPreguntas(item.id_clase)" />
          </template>

        </ComundataTablecomp>
      </v-col>


    </v-row>

    <!------------------------------------->
    <!-- DRAWER EXTRA BANCO DE PREGUNTAS -->
    <!------------------------------------->
    <v-navigation-drawer width="450" app v-model="verPreguntaDrawer" fixed temporary right>
      <v-toolbar dark color="primary">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              <v-icon class="animate__animated animate__heartBeat animate__infinite" right>
                mdi-comment-question-outline</v-icon>
              Banco
            </v-list-item-title>
            <v-list-item-subtitle class="ml-3">
              de preguntas
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="verPreguntaDrawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list rounded v-if="arrayPreguntasClase.length == 0">
        <v-alert :class="classAlertanimate" dense outlined type="error">
          Aun no existen <strong>preguntas</strong> para esta
          <strong>clase </strong>
        </v-alert>
      </v-list>
      <v-list v-else dense nav>
        <ol>
          <v-list-item v-for="item in arrayPreguntasClase" :key="item.idpregunta" link>
            <li v-html="item.titulo"></li>
          </v-list-item>
        </ol>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from "../../../components/ComponentsEst/ComundataTablecomp.vue";
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
export default {
  name: "simuladorEstudianteInicial",
  components: {
    // chipSimulador: () => import("../components/Co-chipSimulador.vue"),
    alertaMensaje: () => import("../components/Co-alertaMensaje.vue"),
    ButtonComp,
    AutocompleteComp,
    ComundataTablecomp
  },
  data: () => ({
    // PROPIEDAD  DEL COMPONENTE CHIP

    // PROPIEDADES DE VARIABLES DE ALERTA
    mostrarSnackbar: false,
    mensajeAlerta: "",

    //  PROPIEDAD DEL COMPONENTE VSELECT
    datoLogin: sessionStorage,
    // LOGICA DE SKELETON
    readyload: false,
    // LOGICA DE TEMAS Y CLASES Y POBLACION DE DATOS
    headersUnidad: [
      { text: "GRADO", value: "desc_grado", class: "header_datatable", align: "center" },
      { text: "UNIDAD", value: "nombre_tema", class: "header_datatable", align: "center" },
      { text: "TEMA", value: "nombre_clase", class: "header_datatable", align: "center" },
      { text: "CREAR SIMULADOR", value: "accion_preguntar", sortable: false, class: "header_datatable", align: "center" },
      {
        text: "VER BANCO DE PREGUNTAS",
        value: "accion_ver",
        class: "header_datatable",
        align: "center",
        sortable: false,
      },
    ],
    loadingBanco: [],
    loadingPregunta: [],

    // CLASS ANIMATE
    classAnimate: "",
    classAlertanimate: "",

    // SIDEBAR DE BANCO DE PREGUNTAS
    verPreguntaDrawer: false,

    // LISTAR PREGUNTAS POR CLASE
    arrayPreguntasClase: [],

    // PROPIEDADES PARA ALERTA
    colorsnackbarAlert: "green",
    snackbarAlert: false,
    timeout: 2000,
    SnackbarTextAlert: "",

    dialogCreaSimuladorMasivo: false,
    itemAlumnosSelected: [],

    // PROPIEDAD IDEXAMEN
    usedCodes: [],

    inhabilitarCursoAlum: true,
    seccion: "",
    filtroProgAlum: [],
    areaAlumno: [],
    cursoAlumno: [],
    cursoAlumFilter: [],

    progAlumno: [],
    progAlumnoFilter: [],
    search: "",
  }),
  methods: {
    /*---------------------*/
    /* METODOS SELECT AREA */
    /*---------------------*/
    selectArea() {
      const me = this;

      me.inhabilitarCursoAlum = false;
      me.cursoAlumFilter = me.cursoAlumno.filter(
        (el) => el.id_area == me.filtroProgAlum.id_area
      );
    },
    /*----------------------*/
    /* METODOS SELECT CURSO */
    /*----------------------*/
    selectCurso() {
      const me = this;

      me.readyload = true;

      setTimeout(() => {
        me.progAlumno = me.progAlumnoFilter.filter(
          (el) => el.id_curso == me.filtroProgAlum.id_curso
        );
        me.readyload = false;
      }, 500);
    },

    /*---------------*/
    /* METODOS PROPS */
    /*---------------*/
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },

    /*--------------------------------*/
    /* FUNCTION FILTRAR ALUMNOS CLASE */
    /*--------------------------------*/
    async ListarAlumnoClase() {

      const me = this;
      me.readyload = true;

      try {

        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/alumnoClase/getQuery${params}`,
          {
            params: {
              search: me.search,
            },
          }
        );

        const { data } = response;

        me.readyload = false;
        me.seccion = data.payload.seccion;
        me.areaAlumno = data.payload.AlumnoArea;
        me.cursoAlumno = data.payload.AlumnoCurso;
        me.progAlumno = data.payload.AlumnoClase;
        me.progAlumnoFilter = data.payload.AlumnoClase;

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*-----------------------------*/
    /* MÉTODO VER BANCO DE PREGUNTAS */
    /*-----------------------------*/
    verBancoPreguntas(idclase) {
      const me = this;
      me.loadingBanco[idclase] = true;
      me.listarPreguntasPorClases(idclase);
    },

    /*----------------------------*/
    /* LISTAR TODAS LAS PREGUNTAS */
    /*----------------------------*/
    async listarPreguntasPorClases(idclase) {
      const me = this;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/lista/" +
          idclase
        );
        me.arrayPreguntasClase = response.data;

        setTimeout(async () => {
          NProgress.done();
          me.verPreguntaDrawer = true;
          me.loadingBanco[idclase] = false;
          me.classAlertanimate = "animate__animated animate__bounceIn";
        }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*--------------------------------*/
    /* FUNCION GENERAR CODIGOS RANDOM */
    /*--------------------------------*/
    generateRandomCode(length) {
      // debugger;
      let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let code = "";

      while (code.length < length) {
        let randomChar = characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
        code += randomChar;
      }

      if (this.usedCodes.includes(code)) {
        // If the code is already used, generate a new one recursively
        return this.generateRandomCode(length);
      }

      this.usedCodes.push(code);
      return code;
    },

    /*--------------------------------*/
    /* FUNCION CREAR EXAMEN ALEATORIO */
    /*--------------------------------*/
    async simularExamen(tipo_contenido, clases) {
      // DEFINE SI CLASE ES ARRAY O SIMPLE STRING NÚMERICO
      let URI;
      if (tipo_contenido == 0) {
        URI = "/simulador/simuladorExamenColegio/simuladorAdmRespuestas/simuladorAdmR/listaresAdm/"
      } else {
        URI = "/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listares/"
      }

      const me = this;
      let ClasesArray = [];
      let Usuarios = [];

      me.loadingPregunta.push(clases);
      ClasesArray[0] = clases;
      Usuarios[0] = me.datoLogin.id;

      try {
        const response = await axios.get(
          URI +
          ClasesArray
        );

        // console.log(response);

        if (response.data.length != 0) {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();

          let map = new Map();
          response.data.forEach((currentValue) => {
            map.has(currentValue.idpregunta)
              ? map.get(currentValue.idpregunta).push({
                estado: currentValue.estado,
                pregunta: currentValue.pregunta,
                idrespuesta: currentValue.idrespuesta,
                idtema: currentValue.idtema,
                orden: currentValue.orden,
                respuesta: currentValue.respuesta,
                valor_respuesta: currentValue.valor_respuesta,
              })
              : map.set(currentValue.idpregunta, [
                {
                  estado: currentValue.estado,
                  pregunta: currentValue.pregunta,
                  idrespuesta: currentValue.idrespuesta,
                  idtema: currentValue.idtema,
                  orden: currentValue.orden,
                  respuesta: currentValue.respuesta,
                  valor_respuesta: currentValue.valor_respuesta,
                },
              ]);
          });

          const arr = Array.from(map, ([idpregunta, respuestas]) => {
            return { idpregunta, respuestas };
          });

          const PreguntaArrayRandom = [];
          const arrayMapRandom = arr;
          var obj = arrayMapRandom.sort(() => Math.random() - 0.5);
          for (let i = 0; i < 6; i++) {
            PreguntaArrayRandom.push(obj[i]);
          }

          // console.log('simulacion',PreguntaArrayRandom);

          await me.guardarDetalleExamen(PreguntaArrayRandom, clases, Usuarios, tipo_contenido);
        } else {
          setTimeout(async () => {
            if (!clases.isArray) {
              me.loadingPregunta.splice(
                this.loadingPregunta.indexOf(clases),
                1
              );
            }

            me.snackbarAlert = true;
            me.colorsnackbarAlert = "red";
            me.SnackbarTextAlert = "No hay preguntas para esta clase";
            me.dialogCreaSimuladorMasivo = false;
            me.itemAlumnosSelected = [];
          }, 500);
        }
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /*---------------------------------------*/
    /* FUNCION GUARDAR EXAMEN DETALLE ALUMNO */
    /*---------------------------------------*/
    async guardarDetalleExamen(itemRespuestas, clases, usuarios, tipo_contenido) {
      const me = this;
      let URI;
      if (tipo_contenido == 0) {
        URI = "/simulador/simuladorExamenColegio/simuladorAdmExamenes/simuladorAdmE/registraAdmExamen"
      } else {
        URI = "/simulador/simuladorExamen/simuladorExamenes/simuladorE/registraExamen"
      }
      itemRespuestas.forEach((obj) => {
        obj.idexamen = "";
        obj.valor_pregunta = false;
        obj.respuestas;
      });

      try {
        let fecha = new Date();
        let dia = fecha.getDay();
        let milisegundos = dia + fecha.getMilliseconds();
        let codigoRan = me.generateRandomCode(6);
        await axios.post(
          URI,
          {
            usuarios: usuarios,
            perfil: this.datoLogin.licencia_perfil.toUpperCase(), //VALIDAR QUE SIEMPRE SEA EL ESTUDIANTE QUIEN EJECUTE ESTO
            descripcion: "",
            observacion: "",
            codigo: `EX${milisegundos}-${codigoRan}`,
            calificacion: "",
            estado: true,
            idautor: me.datoLogin.id,
            tipo_muestra: "SIMULADOR",
            clases: clases,
            prioridad: 0,
            id_ano_lectivo: +me.datoLogin.id_ano_lectivo,
            id_colegio: +me.datoLogin.id_colegio,
            respuestas: itemRespuestas,
          }
        );

        // await me.listarExamen();

        setTimeout(async () => {
          NProgress.done();

          me.loadingPregunta.splice(this.loadingPregunta.indexOf(clases), 1);

          this.$router.push("/lista_simuladores");
          me.$store.commit("changedStateTab");
          // me.tab = "tab-2";
          // me.tab2ClassAnimate = "animate__animated animate__heartBeat";
          // me.claseAnimada = "animate__animated animate__bounceIn";

          setTimeout(() => {
            // me.tab2ClassAnimate = "";
            // me.claseAnimada = "";
          }, 700);
        }, 800);
        // me.dialogCreaSimuladorMasivo = false;
        // me.itemAlumnosSelected = [];
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    /*----------------*/
    /* FUNCION INICIO */
    /*----------------*/
    async init() {
      const me = this;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();
      me.$store.commit("mostrarLoading", {
        titulo: "Cargando Temas ...",
        color: "#fff",
        colorDialog: "#212121",
        ancho: 300,
      });

      try {

        setTimeout(async () => {
          NProgress.done();
          me.$store.commit("ocultarLoading");
        }, 500);

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
  },
  mounted() {
    this.ListarAlumnoClase();
    this.init();
  },
};
</script>
<style scoped>

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#confetti-canvas {
  z-index: 99999;
}
</style>
